module.exports = __webpack_public_path__ + "SC05_Player.4b6b7a8c.png";